import WidgetInfo, {
  renderPermissionStatus,
  renderVerificationStatus,
} from './WidgetInfo';

export default WidgetInfo;
export {
  renderPermissionStatus,
  renderVerificationStatus,
}
